import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { ConfirmDialogService } from '../services/confirm-dialog.service';
import { IsSaveRequired } from '../models';

@Injectable({
    providedIn: 'root'
})
export class ConfirmDeactivateGuard implements CanDeactivate<IsSaveRequired> {

    constructor(private dialogService: ConfirmDialogService) { }

    canDeactivate(target: IsSaveRequired, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Promise<boolean> | boolean {
        if (target.isSaveRequired(currentRoute, currentState, nextState)) {
            const message = 'You have unsaved changes. Are you sure you want to leave the page? All of your changes will be lost.';
            return this.dialogService.confirm(message);
        }
        return true;
    }
}
